import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "idCard"
const IdCardIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.625 14.25C10.451 14.25 11.418 15.076 11.905 15.941 12.14 16.361 12.258 16.778 12.315 17.087 12.346 17.243 12.36 17.373 12.368 17.467Q12.373 17.536 12.374 17.576L12.375 17.61V17.624L12 17.625H12.375V18H4.875V17.577L4.884 17.467C4.891 17.372 4.905 17.242 4.934 17.086 4.992 16.778 5.11 16.361 5.345 15.941 5.832 15.076 6.8 14.25 8.625 14.25M18.375 15.375C18.789 15.375 19.125 15.711 19.125 16.125S18.789 16.875 18.375 16.875H14.625C14.211 16.875 13.875 16.539 13.875 16.125S14.211 15.375 14.625 15.375zM18.375 12.375C18.789 12.375 19.125 12.711 19.125 13.125S18.789 13.875 18.375 13.875H14.625C14.211 13.875 13.875 13.539 13.875 13.125S14.211 12.375 14.625 12.375zM8.625 8.25C10.075 8.25 11.25 9.425 11.25 10.875S10.075 13.5 8.625 13.5 6 12.325 6 10.875 7.175 8.25 8.625 8.25M18.375 9.375C18.789 9.375 19.125 9.711 19.125 10.125S18.789 10.875 18.375 10.875H14.625C14.211 10.875 13.875 10.539 13.875 10.125S14.211 9.375 14.625 9.375z" />
          <path
            fillRule="evenodd"
            d="M21 4.875C21.828 4.875 22.5 5.547 22.5 6.375V19.875C22.5 20.703 21.828 21.375 21 21.375H3C2.172 21.375 1.5 20.703 1.5 19.875V6.375C1.5 5.547 2.172 4.875 3 4.875zM3 19.875H21V6.375H3z"
            clipRule="evenodd"
          />
          <path d="M12.75 2.625C13.164 2.625 13.5 2.961 13.5 3.375V4.125H10.5V3.375C10.5 2.961 10.836 2.625 11.25 2.625z" />
        </svg>
      }
    </span>
  )
}
export default IdCardIcon
